import {RecentError} from '../types/RecentError';

/** Pure: append an error and keep only the most recent `max` entries. */
export const appendRecentError = (
  current: RecentError[],
  error: RecentError,
  max: number
): RecentError[] => [...current, error].slice(-max);
